import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Footer from "@/components/Footer";
import QuoteForm from "@/components/QuoteForm";
import { LOGO_URL, PHONE, PHONE_TEL } from "@/lib/siteData";

export function useLandingMeta({ title, description, jsonLd }) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", `https://mdcourtage.fr${window.location.pathname}`);
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = JSON.stringify(jsonLd);
    document.head.appendChild(s);
    window.scrollTo(0, 0);
    return () => { s.remove(); document.title = prev; };
  }, [title, description, jsonLd]);
}

export default function LandingLayout({ testId, children, needs, page }) {
  return (
    <div className="bg-md-bg min-h-screen text-md-text" data-testid={testId}>
      <header className="bg-white/90 backdrop-blur-md border-b border-md-border sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 flex items-center justify-between gap-4">
          <Link to="/" data-testid="landing-logo-link"><img src={LOGO_URL} alt="MD Courtage" className="h-12 object-contain" /></Link>
          <div className="flex items-center gap-3">
            <a href={`tel:${PHONE_TEL}`} data-testid="landing-phone" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-md-primary"><Phone className="w-4 h-4" /> {PHONE}</a>
            <a href="#devis" data-testid="landing-cta-header" className="bg-md-secondary hover:bg-md-secondaryHover text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-colors">Devis gratuit</a>
          </div>
        </div>
      </header>
      {children}
      <QuoteForm defaultNeeds={needs} page={page} />
      <Footer />
    </div>
  );
}

export const Benefit = ({ title, desc, i }) => (
  <div className="bg-white border border-md-border rounded-3xl p-7 hover:-translate-y-1 transition-transform duration-300" data-testid={`landing-benefit-${i}`}>
    <div className="font-serif text-4xl text-md-secondary mb-3">0{i + 1}</div>
    <h3 className="font-serif text-2xl text-md-primary font-medium mb-2">{title}</h3>
    <p className="text-sm text-md-muted leading-relaxed">{desc}</p>
  </div>
);
